import { render, staticRenderFns } from "./CouponTwo.vue?vue&type=template&id=d87bea96&scoped=true"
import script from "./CouponTwo.vue?vue&type=script&lang=js"
export * from "./CouponTwo.vue?vue&type=script&lang=js"
import style0 from "./CouponTwo.vue?vue&type=style&index=0&id=d87bea96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87bea96",
  null
  
)

export default component.exports